import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Lookup,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { otrAlwList } from "./data";

export default function OtherAllowance(props) {
  const { payrollSEQ } = props;

  const [dataSource, setDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const otherAllowanceGridRef = useRef(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/otrAlw/${userInfo.employeeNo}/${payrollSEQ}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/otrAlw/${userInfo.employeeNo}/${payrollSEQ}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/otrAlw/${userInfo.employeeNo}/${payrollSEQ}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/otrAlw/${userInfo.employeeNo}/${payrollSEQ}/${key}`
          );
        },
      })
    );
  }, []);

  const onInitNewRow = (e) => {
    const key = otherAllowanceGridRef.current.instance.getKeyByRowIndex(0);

    if (key) {
      e.component.selectRows(key, true);
      e.data = otherAllowanceGridRef.current.instance.getSelectedRowsData()[0];
    }
  };

  return (
    <DataGrid
      id="otherAllowanceGrid"
      ref={otherAllowanceGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onInitNewRow={onInitNewRow}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Other Allowance"}
          confirmDeleteMessage={
            "Are you sure you want to delete this other allowance?"
          }
        />
        <Popup title={"Other Allowance"} showTitle={true} height={200} />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="otherAllowance"
          height={"100%"}
        >
          <SimpleItem
            dataField={"otrAlw"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: otrAlwList,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
            }}
          >
            <Label text={"항목"} />
          </SimpleItem>
          <SimpleItem
            dataField={"amt"}
            editorType="dxNumberBox"
            editorOptions={{
              showClearButton: true,
              format: "#0원",
            }}
          >
            <Label text={"금액"} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column dataField={"otrAlw"} caption="항목">
        <Lookup dataSource={otrAlwList} valueExpr="id" displayExpr={"name"} />
      </Column>
      <Column
        dataField={"amt"}
        caption="금액"
        dataType={"number"}
        format={"#,##0원"}
      />
    </DataGrid>
  );
}
